import React from 'react';
import { Card, Avatar, Tag } from 'antd';
import {
    MailOutlined,
    PhoneOutlined,
    CalendarOutlined,
    UserOutlined,
    BankOutlined,
    DollarOutlined
} from '@ant-design/icons';
import { cn } from '../../utils/cn';
import { getInitials } from '../../utils/helper';
import { formatDateTime } from '../../utils/functions';

const EnhancedAffiliatesCustomersCardView = ({
    record,
    onCardClick,
}) => {
    const initials = getInitials(record.name);
    return (
        <Card
            hoverable
            className="h-full relative"
            onClick={() => onCardClick && onCardClick(record)}
        >
            <div className="space-y-4">
                {/* Header */}
                <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-3 overflow-hidden">
                        <Avatar
                            size={48}
                            className={cn("flex-shrink-0 font-semibold text-lg", "!bg-primary")}
                        >
                            {initials}
                        </Avatar>
                        <div className="min-w-0 flex-1">
                            <h3 className="font-semibold text-base mb-1 truncate" title={record.name}>
                                {record.name || "N/A"}
                            </h3>
                        </div>
                    </div>
                </div>

                {/* Contact Info */}
                <div className="space-y-2 border-b border-gray-200 pb-3">
                    <div className="flex items-center text-sm text-gray-600">
                        <MailOutlined className="mr-2 flex-shrink-0" />
                        <span className="truncate" title={record.email ?? "user-email"}>{record.email ?? "-"}</span>
                    </div>
                    <div className="flex items-center text-sm text-gray-600">
                        <PhoneOutlined className="mr-2 flex-shrink-0" />
                        <span className="truncate" title={record.phone ?? "user-phone"}>{record.phone ?? "-"}</span>
                    </div>
                </div>

                {/* Plan & Commission Info */}
                <div className="space-y-3">
                    {/* Plan */}
                    <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-600 font-medium">
                            <BankOutlined className="mr-1" />
                            Plan:
                        </span>
                        <Tag color="blue" className="capitalize">
                            {record.planPrice}
                        </Tag>
                    </div>

                    {/* Commission */}
                    <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-600 font-medium">
                            <DollarOutlined className="mr-1" />
                            Commission:
                        </span>
                        <span className="text-sm font-semibold text-green-600">
                            {record.commission}
                        </span>
                    </div>

                    {/* Registered At */}
                    <div className="flex items-center justify-between border-t border-gray-200 pt-3">
                        <span className="text-sm text-gray-600 font-medium">
                            <CalendarOutlined className="mr-1" />
                            Registered:
                        </span>
                        <span className="text-sm text-gray-700">
                            {record.registeredAt}
                        </span>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default EnhancedAffiliatesCustomersCardView;
